module.exports = __webpack_public_path__ + "static/Prause_Logo-17_banner-3ea5080a3beed5b407c86dea499cf513.png";